import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { getAuthProps, handleRefreshAuthProps } from "../../lib/authenticationLibrary";
import { encryptAES } from "../../services/CryptoService";


const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION === 'true';

const IsProdMode = false;
const API_URL = (IsProdMode) ? process.env.REACT_APP_TEST_SITE_URL : process.env.REACT_APP_BASE_URL
 
const baseQuery = fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
        headers.set("Content-Type", "application/json");
        let authData = getAuthProps();
        if (authData) {
            const token = authData.token.token;
            headers.set("Authorization", `Bearer ${token}`)
        }
        if (isEncryptionEnabled) {
            headers.set('is-enc', `true`);
        }
        return headers;
    }
});

export const uploadFileBaseQuery = fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
        const authData = getAuthProps();
        if (authData?.token?.token) {
            headers.set('Authorization', `Bearer ${authData.token.token}`);
        }

        // 👇 Do NOT set Content-Type
        return headers;
    },
});


export const defaultBaseQuery = async (args, api, extraOptions) => {
    const authData = getAuthProps();
    let token = null;
    if (authData)
        token = authData.token.token;

    // if (!token) {
    //     window.location.href = '/login';
    //     return;
    // }

    if (isEncryptionEnabled) {

        let [b, paramString] = args.url.split('?');

        if (paramString) {
            paramString = encryptAES(paramString);
            args.url = `${b}?${paramString}`;
        }


        if (args.body) {
            args.body = encryptAES(args.body);
        }

    }

    let result = await baseQuery(args, api, extraOptions);

    if (result.error) {
        if (result.error.status === 401) {
            window.location.href = '/login';
        }
    }

    const sessionTimeout = result?.meta?.response?.headers?.get("sessionTimeOut");
    const refreshedToken = result?.meta?.response?.headers?.get("x-refreshed-token");
    const tokenExpiresAt = result?.meta?.response?.headers?.get("x-token-expires-at");

    if (refreshedToken && tokenExpiresAt && sessionTimeout) {
        let request = {
            token: {
                token: refreshedToken,
                expires: tokenExpiresAt,
            },
            sessionTimeout
        }
        handleRefreshAuthProps(request);
    };


    return result;
}

